/**
 * Productos para adultos (+18), 1.0 functions/lib/adultContent.js transcrito el 13/10. Un anuncio
 * es adulto si el admin lo fuerza (`adult_override`), si cuelga de la raíz `adult` del árbol, o si
 * su texto contiene términos inequívocos (juguetes sexuales); en ese caso se recoloca en
 * `adult_toys` para que no salga en Mujer/Hombre. Los términos del admin se añaden por parámetro.
 */
function norm(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’-]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export const ADULT_AUTO_CATEGORY = 'adult_toys';

// Ya normalizados (sin acentos, minúsculas). `*` final = cualquier terminación.
export const ADULT_TERMS: readonly string[] = [
  // es / pt
  'masturbador*',
  'vibrador*',
  'consolador*',
  'dildo*',
  'succionador* de clitoris',
  'succionador* clitoris',
  'satisfyer',
  'juguete* sexual*',
  'juguete* erotico*',
  'plug anal',
  'bolas chinas',
  'anillo vibrador',
  'muneca* hinchable*',
  'muneca* sexual*',
  'brinquedo* sexua*',
  'brinquedo* erotico*',
  // en
  'sex toy*',
  'sextoy*',
  'vibrator*',
  'masturbator*',
  'butt plug*',
  'cock ring*',
  'fleshlight*',
  'strap on',
  'anal bead*',
  'love egg*',
  'sex doll*',
  'penis pump*',
  'g spot vibrator*',
  // fr / it / de / nl
  'godemiche*',
  'vibromasseur*',
  'masturbateur*',
  'poupee* gonflable*',
  'jouet* sexuel*',
  'giocattol* sessual*',
  'vibratore*',
  'masturbatore*',
  'sexspielzeug*',
  'liebeskugel*',
  'analplug*',
  'penisring*',
  'seksspeeltje*',
  'erotisch speelgoed',
  // pl / ro / hu / nórdicos / fi
  'wibrator*',
  'zabawk* erotyczn*',
  'jucari* sexual*',
  'jucari* erotic*',
  'maszturbator*',
  'szexjatek*',
  'anal dugo*',
  'sexleksak*',
  'sexlegetoj*',
  'sexleketoy*',
  'seksilelu*',
  'vibraattori*',
  // añadidos 2026-10-08 (anuncios que se escapaban)
  'satisfayer',
  'womanizer',
  'kegel',
  'bolas kegel',
  'bola* de kegel',
  'huevo* vibrador*',
  'juguete* intimo*',
  'juguete* para adulto*',
  'articulo* para adulto*',
  'estimulador* de clitoris',
  'estimulador* clitoris',
  'estimulador* prostat*',
  'masajeador* prostat*',
  'anillo* para el pene',
  'anillo* pene',
  'bala* vibradora*',
  'kegel ball*',
  'ben wa',
  'prostate massager*',
  'clitoral*',
];

/** "bola* de kegel" → RegExp de palabra completa sobre el texto normalizado. */
export function compileAdultTerm(t: string): RegExp | null {
  const parts = t
    .split(' ')
    .filter(Boolean)
    .map((w) => (w.endsWith('*') ? `${norm(w.slice(0, -1))}[a-z0-9]*` : norm(w)))
    .filter(Boolean);
  if (parts.length === 0) return null;
  return new RegExp(`(?:^| )${parts.join(' ')}(?: |$)`);
}

const BUILTIN = ADULT_TERMS.map((term) => ({ term, re: compileAdultTerm(term) })).filter(
  (x): x is { term: string; re: RegExp } => x.re !== null,
);

export interface AdultCheckInput {
  title?: string;
  description?: string;
  search_keywords?: string;
  brand?: string;
  category_path?: readonly string[] | null;
  adult_override?: string | null;
}

/** Término adulto encontrado en el texto del anuncio, o null. */
export function findAdultTerm(
  p: AdultCheckInput,
  extraTerms: readonly string[] = [],
): string | null {
  const text = norm(
    [p.title, p.description, p.search_keywords, p.brand]
      .map((x) => x ?? '')
      .join(' ')
      .slice(0, 3000),
  );
  if (!text) return null;
  for (const { term, re } of BUILTIN) if (re.test(text)) return term;
  for (const t of extraTerms) {
    const re = compileAdultTerm(t);
    if (re?.test(text)) return t;
  }
  return null;
}

/** Veredicto +18 con la prioridad de la 1.0: override admin > raíz adulta > términos. */
export function isAdultListing(
  p: AdultCheckInput,
  extraTerms: readonly string[] = [],
): { adult: boolean; reason: 'override' | 'category' | 'term' | null; term?: string } {
  if (p.adult_override === 'adult') return { adult: true, reason: 'override' };
  if (p.adult_override === 'safe') return { adult: false, reason: 'override' };
  if ((p.category_path ?? []).includes('adult')) return { adult: true, reason: 'category' };
  const term = findAdultTerm(p, extraTerms);
  return term ? { adult: true, reason: 'term', term } : { adult: false, reason: null };
}
